<script setup>
const props = defineProps({
  customTitle: {
    boolean: String,
    default: 'Doradca VEHIS poleca'
  },
  typeDataLayer: {
    type: String,
    default: () => 'home_section_2'
  },
  isMoto: {
    type: Boolean,
    default: () => false
  }
})
const backend = useBackend();

const refSlideControl = ref();
const refSlideNavigation = ref();

const { data: blocks } = await useAsyncData('blocks', async () => {
  const result = await backend.getModelDescriptionCards();
  if (!result?.data || !result.data.length) return [];

  const first = result.data.find(item => item.is_first);
  const rest = result.data.filter(item => !item.is_first);

  for (let i = rest.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [rest[i], rest[j]] = [rest[j], rest[i]];
  }
  return first ? [first, ...rest] : rest;
});

const updateSlideNumber = (slideNumber) => {
  refSlideNavigation.value.setSlide(slideNumber);
}

const scrollToSlide = (slide) => {
  refSlideControl.value.scrollToSlide(slide);
}

</script>

<template>
  <Container>
    <div v-if="blocks.length" class="-mt-16">
      <div :class="isMoto ? 'flex-col' : 'items center'" class="flex justify-between">
        <VectorVehisHorizontal v-if="isMoto" class="h-5 w-32 mt-4"/>
        <SubContentHeader :class="{'!text-left':isMoto}">{{customTitle}}</SubContentHeader>
      </div>
      <SlideControl ref="refSlideControl"
                    class="-mt-4 !pr-0"
                    @swipeEnd="(slideNumber) => updateSlideNumber(slideNumber)"
      >
        <template v-for="block in blocks">
          <SlideItem>
           <CarDayOfferCard :typeDataLayer="typeDataLayer" :data="block" />
          </SlideItem>
        </template>
      </SlideControl>
      <SlideNavigation ref="refSlideNavigation"
                       class="-mt-4"
                       :items=blocks?.length
                       @changed="(slide) => scrollToSlide(slide)"
      />

    </div>
  </Container>

</template>
